








import { Component, Vue, Emit } from 'vue-property-decorator'

@Component({
  components: {
  },
})
export default class WebCam extends Vue {

  public $refs!: {
    video: HTMLVideoElement;
  }

  public get video(): HTMLVideoElement { return this.$refs.video }

  private async mounted() {
    const stream = await navigator.mediaDevices.getUserMedia({ video: {} })

    this.video.srcObject = stream
  }

  @Emit('loaded')
  private onLoaded() {
    return
  }
}
